import React, { useState } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import Button from '../../../common/button/Button'
import Icons from '../../../common/icons/Icons'
import { QueryClient, useQuery } from '@tanstack/react-query'
import { performRequest } from '../../../common/utils'
import Modal from '../../../common/modal/Modal'
import ResponseMessage from '../../../common/modal/ResponseMessage'
import { getLDGroupLabel } from '../ReportingGroup/utils'
import { getPaletteColor } from './Utils'

const MemberTabs = ({
  groupData = [],
  teamData
}) => {

  const params = useParams()
  const root = `/organization/${params.team_id}`
  const [ responseMessage, setResponseMessage ] = useState('')
  const modalId = 'msync-membership-leave-group-modal'

  const queryClient = new QueryClient()

  const {
    isLoading,
    isRefetching,
    refetch,
    data } = useQuery({
      queryKey: ['msync_leave_group'],
      queryFn: leaveGroup,
      refetchOnWindowFocus: false,
      enabled: false,
    }, queryClient)

  async function leaveGroup() {
    // const formData = new FormData()
    // formData.append('action', 'msync_leave_group')
    // formData.append('group_id', groupData.group_id)
    // formData.append('nonce', group_dashboard.nonce_members)
    try{
      // const request = await performRequest(group_dashboard.ajaxurl, formData)
      // const res = await request.json()
      const res = await Tangible?.ajax('msync_leave_group', {
        group_id: groupData.group_id,
      })
      if( !res.success ){
        throw new Error( res.errors.shift() )
      }
      setResponseMessage({
        type: 'success',
        message: res.response
      })
      setInterval(() => {
        window.location.href = window.location.pathname;
      }, 2000);
      return res.response
    }catch (error){
      console.error( error )
      setResponseMessage({
        type: 'error',
        message: error.toString()
      })
      return false
    }
  }

  const ldGroupLabel = getLDGroupLabel( teamData )
  
  return (  
    <>
    <nav className="msync-organization-dashboard__header__navigation" id="msync-member-tabs">
      <div className="msync-organization-dashboard__header__navigation__part msync-organization-dashboard__header__navigation__part--nav-main">
        <NavLink
          to={`${root}/member-home`}
          className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
          end
        >
          <Icons type='home'/>
          <span>Home</span>
        </NavLink>
        <NavLink
          to={`${root}/manage`}
          className={({ isActive }) => isActive ? "active msync-button" : "msync-button msync-button--is-theme-secondary msync-button--is-style-link" }
        >
          <Icons type='settings' />
          <span>Manage</span>
        </NavLink>
      </div>
      <div className="msync-organization-dashboard__header__navigation__part">
        <a
          href={ groupData.group_url ?? '#' }
          className="msync-button msync-button--is-style-outline"
        >
          <Icons type='users' />
          Go to { ldGroupLabel }
        </a>
        <Button
          className="msync-button--is-style-outline msync-button--is-theme-destructive"
          onClick={ () => MicroModal.show(modalId) }
        >
          <Icons type='leave' />
          <span>Leave { ldGroupLabel }</span>
        </Button>
      </div>
    </nav>

    <Modal 
      modalId={modalId}
      modalHeading="Leave { ldGroupLabel }"
      buttonTitle="" 
      modalClassNames={'msync-members-custom-modal'}
    >
      <main className="msync-modal__body">
        { responseMessage && <ResponseMessage response={ responseMessage } /> }
        <p>
          Are you sure you want to leave <strong>{ groupData.group_name ?? '' }?</strong><br/>
          <span>You won't be able to rejoin unless you receive a new invitation.</span>
        </p>
      </main>
      <footer className="msync-modal__footer">
        <Button 
          name='Cancel'
          className="msync-button--is-style-outline msync-button--is-theme-destructive" 
          data-micromodal-close
          aria-label="Close this dialog window"
        />
        <Button 
          type='button' 
          name={ isLoading || isRefetching ? 'Leaving...' : 'Confirm' }
          onClick={ () => refetch() } disabled={ isLoading || isRefetching ? true : false}
        />
      </footer>
    </Modal>
    </>

  )
}

export default MemberTabs
